import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import SubCategory from "../views/SubCategory.vue";
import SubItem from "../views/SubItem.vue";
import Cart from "../views/Cart.vue";
import UserDetails from "../views/UserDetails.vue";
import TableSelection from "../views/TableSelection.vue";
import Payment from "../views/Payment.vue";
import OrderDetails from "../views/OrderDetails.vue";
import TimeSlotSelection from "../views/TimeSlotSelection.vue";
import CategoryCategory from "../views/CategoryCategory.vue";
import KioskStart from "../views/KioskStart.vue";
import Main from "../views/Main.vue";
import HomeScreenKiosk from "../views/HomeScreenKiosk.vue";
import DeliveryStart from "../views/DeliveryStart.vue";
import LandingPage from "../views/LandingPage.vue";
import PickUpScreen from "../views/PickUpScreen.vue";
import CcvProcessor from "../views/CcvProcessor.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/:menuHash?/ccv",
    name: "CcvProcessor",
    component: CcvProcessor,
    meta: { transition: "fade", embedded: true },
  },
  {
    path: "/:menuHash?/:stickerId?",
    name: "Home",
    component: Home,
    meta: { transition: "fade" },
  },
  {
    path: "/:menuHash?/start/kiosk",
    name: "KioskStart",
    component: KioskStart,
  },
  {
    path: "/:menuHash?/delivery/take-out",
    name: "DeliveryStart",
    component: DeliveryStart,
  },
  {
    path: "/:menuHash?/pickup/screen",
    name: "PickUpScreen",
    component: PickUpScreen,
  },
  {
    path: "/:menuHash?/startscreen/test",
    name: "HomeScreenKiosk",
    component: HomeScreenKiosk,
  },
  {
    path: "/:menuHash?/:stickerId?/cart",
    name: "Cart",
    component: Cart,
    meta: { transition: "fade" },
  },
  {
    path: "/:menuHash?/:stickerId?/order-details",
    name: "OrderDetails",
    component: OrderDetails,
    meta: { transition: "fade" },
  },
  {
    path: "/:menuHash?/cart/user-details",
    name: "UserDetails",
    component: UserDetails,
    meta: { transition: "fade" },
  },
  {
    path: "/:menuHash?/cart/table-selection",
    name: "TableSelection",
    component: TableSelection,
    meta: { transition: "fade" },
  },
  {
    path: "/:menuHash?/cart/time-slot-selection",
    name: "TimeSlotSelection",
    component: TimeSlotSelection,
    meta: { transition: "fade" },
  },
  {
    path: "/:menuHash?/cart/payment",
    name: "Payment",
    component: Payment,
    meta: { transition: "fade" },
  },
  {
    path: "/:menuHash/sub/:subCategoryId?",
    name: "SubCategory",
    component: SubCategory,
    meta: { transition: "fade" },
  },
  {
    path: "/:menuHash/sub/:subCategoryId?/category/:categoryId/",
    name: "Category",
    component: Main,
    meta: { transition: "fade" },
  },
  {
    path:
      "/:menuHash/sub/:subCategoryId?/category/:categoryId/menuItemId/:menuItemId",
    name: "SubItem",
    component: SubItem,
    meta: { transition: "fade" },
  },
  {
    path: "/:menuHash/category/:categoryId",
    name: "CategoryCategory",
    component: CategoryCategory,
    meta: { transition: "fade" },
  },
  {
    path: "/L/:landingHash/:stickerId?",
    name: "LandingPage",
    component: LandingPage,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const $loader = document.querySelector("#loader");

router.beforeResolve((to, from, next) => {
  if (to.name) {
    $loader.classList.remove("hidden");
    $loader.classList.add("flex");
  }
  next();
});

function hasQueryParams(route) {
  return !!Object.keys(route.query).length;
}

router.beforeEach((to, from, next) => {
  const getUrl = new URL(window.location.href);
  const hasPrint = getUrl.searchParams.get("printerIp");
  const hasRegisterId = getUrl.searchParams.get("registerId");
  const hasMenuHash = router.history.current.params.menuHash;

  if (hasPrint) localStorage.setItem("printerIp", hasPrint);
  if (hasRegisterId) localStorage.setItem("registerId", hasRegisterId);

  /**
   * if a user is redirected to the same location (if a menu hash is entered), just reload the page
   */
  if (hasMenuHash && to.fullPath === from.fullPath) location.reload();
  // otherwise just redirect
  else if (!hasQueryParams(to) && hasQueryParams(from)) {
    next({
      name: to.name,
      query: {
        ...from.query,
        printerIp: localStorage.getItem("printerIp"),
        registerId: localStorage.getItem("registerId"),
      },
      params: to.params,
    });
  } else {
    next();
  }
});

// router.beforeEach((to, from, next) => {
//   // const getUrl = new URL(window.location.href);
//   // const hasMode = getUrl.searchParams.get("mode");
//   // const hasSession = getUrl.searchParams.get("sessionId");

//   // next({
//   //   path: to.path,
//   //   query: Object.assign({}, to.query, from.query)
//   // })

//   // next()
//   next({
//     query: Object.assign({}, to.query, from.query)
//   })
//   // else next()
// });

router.afterEach(() => {
  $loader.classList.add("hidden");
  $loader.classList.remove("flex");
});

export default router;
